import SbuxCard from "../../../components/SbuxCard";
import QuickConnectsTable from "./table/QuickConnectsTable";
import { useAppSelector } from "../../../store/types";
import SbuxFallback from "../../../components/SbuxFallback";
import { getQuickConnectsFilterItem } from "../../../services/filter";
import { QUICKCONNTECTS_DEFAULT_FILTER_ITEMS } from "../../../constants";
import { ErrorBoundary } from "react-error-boundary";
import { logMessage } from "../../../utils/amplifyLogger";
import { clientLog } from "../../../services/logging";
import {
  getCcpContactStatusSelector,
  getCcpEndpointsSelector,
} from "../../../selectors/ccpSelector";
import {
  getQuickConnectsFilterItemSelector,
  getQuickConnectsResetSelector,
} from "../../../selectors/filterSelector";

const QuickConnects = () => {
  const ccpContactStatus = useAppSelector(getCcpContactStatusSelector);
  const endpoints = useAppSelector(getCcpEndpointsSelector);
  const quickConnectsFilterItem = useAppSelector(
    getQuickConnectsFilterItemSelector,
  );
  const quickConnectsReset = useAppSelector(getQuickConnectsResetSelector);
  const handleError = (error: Error) => {
    clientLog({
      component: `QuickConnects`,
      message: `Something went wrong in QuickConnects Component => ${error}`,
    });
    logMessage(
      `Unhandle Error in QuickConnects`,
      `Something went wrong in QuickConnects Component => ${error}`,
      `error`,
    );
  };

  return (
    <ErrorBoundary FallbackComponent={SbuxFallback} onError={handleError}>
      <SbuxCard className="insideTabContainer">
        <QuickConnectsTable
          endpoints={endpoints as Record<string, unknown>[] | null | undefined}
          ccpContactStatus={ccpContactStatus}
          filteredItem={
            !quickConnectsReset && quickConnectsFilterItem.length === 0
              ? QUICKCONNTECTS_DEFAULT_FILTER_ITEMS
              : quickConnectsFilterItem
          }
          quickConnectsReset={quickConnectsReset}
          setFilteredItem={
            getQuickConnectsFilterItem as unknown as (items: string[]) => {
              type: string;
              [key: string]: unknown;
            }
          }
        />
      </SbuxCard>
    </ErrorBoundary>
  );
};

export default QuickConnects;
